import { defineStore } from "pinia";
import { ref } from "vue";

export interface NavigationOption {
  label: string;
  path: string;
}

export const useNavigationStore = defineStore("navigationStore", () => {
  const breadcrumb = ref<string[]>([]);
  const routePath = ref("");
  const submenuOptions = ref<NavigationOption[]>([]);

  const setBreadcrumb = (path: string, labels: string[], options: NavigationOption[] = []) => {
    routePath.value = path;
    breadcrumb.value = labels.filter(Boolean);
    submenuOptions.value = options;
  };

  const clearBreadcrumb = (path: string) => {
    routePath.value = path;
    breadcrumb.value = [];
    submenuOptions.value = [];
  };

  return {
    breadcrumb,
    routePath,
    submenuOptions,
    setBreadcrumb,
    clearBreadcrumb,
  };
});
